import { AppJsonDecoder } from 'src/app/utils/app-json-decoder';
import { License } from './license.model';
import { User } from '../user/user.model';

import isMongoId from 'validator/es/lib/isMongoId';

export class LicenseAssignment {
  id?: string;
  license?: License;
  user?: User;
  key?: string;
  createdAt?: Date;
  updatedAt?: Date;

  constructor(json?: any) {
    if (!json) return;
    if (isMongoId(json.toString().trim())) {
      this.id = json.toString().trim();
      return;
    }
    this.id = json['_id'] || json['id'];
    this.license = new License(json['license']);
    this.user = new User(json['user']);
    this.key = json['key'];
    this.createdAt = AppJsonDecoder.optDate(json['createdAt']);
    this.updatedAt = AppJsonDecoder.optDate(json['updatedAt']);
  }
}
